import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../../context/LanguageContext";

export default function WhyUs() {
  const { t } = useLang();
  const items = t("why.items") || [];

  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16 max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="gold-divider" />
            <span className="label-gold">{t("why.label")}</span>
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-white leading-[1.1] tracking-tight">
            {t("why.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-16 gap-y-2">
          {items.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ delay: (i % 2) * 0.1 }}
              data-testid={`why-item-${i}`}
              className="group py-8 border-b border-white/10 hover:border-[#F2B705]/40 transition-colors"
            >
              <div className="flex items-start gap-6">
                <span className="font-display text-2xl font-bold text-[#F2B705]/70 group-hover:text-[#F2B705] transition-colors w-12 shrink-0 tracking-tighter">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div>
                  <h3 className="font-display text-lg lg:text-xl font-semibold text-white mb-3">
                    {it.t}
                  </h3>
                  <p className="text-sm lg:text-base text-neutral-400 leading-relaxed">
                    {it.d}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
